// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"8f3e3e4f","212":"b8f6b9a9","648":"c311d947","882":"c9ef8dfd","912":"c5cb9cc5"}[chunkId] + ".chunk.css";
};